import store from '../store/index'

export default {
    mounted (el, binding) {
        checkPermission(el, binding)
    },
    updated (el, binding) {
        checkPermission(el, binding)
    }
}

function checkPermission (el, binding) {
    const hasPermission = store.getters.isAllowed(binding.value)

    if (!hasPermission) {
        el.disabled = true
        el.classList.add('disabled-permission-button')
    } else {
        el.disabled = false
        el.classList.remove('disabled-permission-button')
    }
}
